// VoK MUI Base Styles
import colors from "app/assets/theme-dark/base/colors";

const {transparent} = colors;

const iconButton = {
    styleOverrides: {
        root: {
            "&:hover": {
                backgroundColor: transparent.main,
            },
        },
    },
};

export default iconButton;
